module.exports = __webpack_public_path__ + "img/frame (265).7555fd9c.jpg";